import {
    createOverlayComponent,
    IOverlayBusinessLogic,
    IOverlayProperties,
    Overlay,
    OverlayBase,
} from '@vfde-brix/overlay';
import mountAccordion from '../../../components/mountAccordion';
import { handleLegacyClickEventBindings } from '../helper/handleLegacyClickEventBindings';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { OverlayActionDispatchers } from '../action';

let overlay: Overlay;

/**
 * Overlay implementation
 *
 *
 * @param toggleOverlay
 */
export const mountOverlay = (toggleOverlay: OverlayActionDispatchers['toggleOverlay']) => {

    const element = document.createElement('div');
    document.body.appendChild(element);

    const properties: IOverlayBusinessLogic = {
        onClose: () => {
            toggleOverlay();
        },
        onOpen: (overlay: OverlayBase<IOverlayBusinessLogic, IOverlayProperties>) => {
            handleLegacyClickEventBindings(overlay);
        },
    };

    overlay = createOverlayComponent(element, { business: properties });

    return overlay;
};

/**
 * Show the overlay
 *
 * @param overlayContent - Pass the response so that the overlay can inject its content
 */
export const showOverlay = (overlayContent: string | HTMLElement): void => {
    overlay.injectContent(overlayContent);
    overlay.open();
};

/**
 * Show the overlay
 *
 * @param overlayContent - Pass the response so that the overlay can inject its content
 */
export const getOverlayContent = (): HTMLElement => overlay.getOverlayContentContainer();

/**
 * Show the overlay
 *
 * @param overlayContent - Pass the response so that the overlay can inject its content
 */
export const showLocalOverlay = (overlayContent: string | HTMLElement): void => {
    overlay.injectContent(overlayContent);
    overlay.open();
};

/**
 * mount Accordion in Overlay
 */
export const mountOverlayAccordion = (containerId: string): void => {
    const container = document.getElementById(containerId);
    container && mountAccordion(container, NO_PATTERN_BUSINESS_LOGIC);
};

/**
 * Show the overlay
 */
export const closeOverlay = (): void => {
    overlay.close();
};
